export default __webpack_public_path__ + "static/media/video-preview-two.d8ab261b.jpg";